import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { CdkScrollable, ScrollDispatcher } from "@angular/cdk/overlay";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { debounceTime, filter, map, shareReplay, takeUntil, tap } from "rxjs/operators";
import { HeaderService } from "src/app/components/header/header.service";
import { ShipyardService } from "./../../shipyard.service";
import { PlanShipmentDialogComponent } from "../plan-shipment-dialog/plan-shipment-dialog.component";
import { CreateDraftShipmentPayload } from "./../../../../models/shipyard.model";
import { StorageKeyEnum } from '../../../../core/StorageKeyEnum';
import { ShipmentDetail } from "./../../../../models/shipyard.model";
import { AuthService } from '../../../../services/auth.service';
import {SnackbarComponent} from '../../../../components/snackbar/snackbar.component';
import { SettingsService } from "../../../../services/settings.service";
import { Subject } from "rxjs";

@Component({
  selector: "app-add-sku-to-shipment",
  templateUrl: "./add-sku-to-shipment.component.html",
  styleUrls: ["./add-sku-to-shipment.component.scss"],
})
export class AddSkuToShipmentComponent implements OnInit,OnDestroy {
  selectedShipment: number;
  selectedShipmentPlan: number;
  selectedPlan: any;
  private _selectedTab = "All";
  shipments = [];
  account;
  startRow = 0;
  amountPerPage = 10000;
  loading: boolean;
  shipmentPlans: any[];
  shipmentType: any;
  shipmentsNew: any = {};
  selectedIndex: any;
  data: any;
  get selectedTab() {
    return this._selectedTab;
  }
  set selectedTab(value) {
    this._selectedTab = value;
    this.startRow = 0;
    this.selectedShipment = null;
    this.selectedShipmentPlan = null;
    this.shipments = [];
    this.shipmentsNew = {};
    this.getShipments();
  }
  private destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public response: any,
    public dialogRef: MatDialogRef<AddSkuToShipmentComponent>,
    private shipyardService: ShipyardService,
    private headerService: HeaderService,
    private scrollDispatcher: ScrollDispatcher,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private settingsService: SettingsService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    if(this.response?.isAddToDraftShipment) this._selectedTab = 'draft'
    this.data = this.response.shipment;
    this.shipmentType =
      this.data.shipmentHeaderId === ""
        ? this.data.shipmentTypeId.toString()
        : this.shipyardService.getShipmentTypeId(this.data.shipmentType);
    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.account = e;
      this.startRow = 0;
      this.getShipments();
    });
    this.scrollDispatcher
      .scrolled()
      .pipe(
        tap((data: CdkScrollable) => {}
        ),
        filter(
          (data: CdkScrollable) => data.measureScrollOffset("bottom") <= 1
        ),
        debounceTime(150)
      )
      .subscribe((data: CdkScrollable) => {
        this.startRow += this.amountPerPage;
        this.getShipments();
      });

    this.shipyardService
      .GetShipmentPlans(this.shipmentType)
      .pipe(takeUntil(this.destroy$)).subscribe((e: any[]) => {
        this.shipmentPlans = e;
      });
      
  }

  getShipments() {
    this.loading = true;
    this.shipyardService
      .GetShipments(
        this.account,
        this.startRow,
        this.startRow + this.amountPerPage,
        this.selectedTab === "All" ? ["WORKING", "draft" ,"IN_TRANSIT", "READY_TO_SHIP", "CHECKED_IN", "SHIPPED"] :  this.selectedTab === "working" ? ["WORKING","IN_TRANSIT", "READY_TO_SHIP", "CHECKED_IN", "SHIPPED"] : [this.selectedTab],
        this.shipmentType
      )
      .pipe(
        map((e: ShipmentDetail[]) =>
          e.filter(
            (shipment: ShipmentDetail) =>
              shipment.shipmentHeaderId !== this.data.shipmentHeaderId
          )
        )
      )
      .subscribe((array: any[]) => {
        if (!this.startRow) {
          this.shipments = [];
          this.shipmentsNew = {};
        }
        array = array.filter((res)=> !res.isCompleted);
        this.shipments.push(...array);
        this.shipmentsNew = this.shipments.reduce((currentValue, next) => {
          if (!currentValue.hasOwnProperty(next.status)) {
            currentValue[next.status] = [];
          }
          currentValue[next.status].push(next);
          return currentValue;
        }, {});
        this.shipmentsNew["IN_TRANSIT"]?.forEach(res=>{
          if(this.shipmentsNew.hasOwnProperty("WORKING"))
          this.shipmentsNew["WORKING"].push(res);
          else{
            this.shipmentsNew["WORKING"] = [];
            this.shipmentsNew["WORKING"].push(res);
          }
        })
        this.loading = false;
      });
  }

  close() {
    this.dialogRef.close();
  }

  confrim() {
    this.loading = true;
    if (this.selectedShipmentPlan) {
      this.confirmEditShipment(this.selectedShipmentPlan);
    } else {
      if (this.data.shipmentHeaderId === "") {
        this.editShipment();
      } else {
        this.mergeShip();
      }
    }
  }

  confirmEditShipment(shipmentPlanHeaderId?) {
    const skus = this.data.skus;
    const payload = {
      skus,
      shipmentHeaderId: null,
      appendQty: false,
    };
    const payload1 = {
      shipmentPlanHeaderId: shipmentPlanHeaderId,
      shipmentId: null,
      shipmentName: null,
    };

    this.shipyardService.ConfirmShipment(payload1).pipe(takeUntil(this.destroy$)).subscribe({
      next: (e:any) => {
        const shipmentHeaderId = e[0].shipmentHeaderId;
        payload.shipmentHeaderId = shipmentHeaderId;
        this.shipyardService.EditShipmentSku(payload).pipe(takeUntil(this.destroy$)).subscribe({
          next: (e:any) => {
            this.loading = false;
            this.router.navigate(["/shipyard/shipments/detail/", shipmentHeaderId]);
            this.freemiumAvailable();
            this.dialogRef.close();
          },
         error: (err) => {
          this.loading = false;
          this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: err.error.error[0],
                  action: 'Dismiss',
                    type: 'error',
                },
              }
          );
         }
       });
      },
     error: (err) => {
      this.loading = false;
      this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: err.error.error[0],
              action: 'Dismiss',
                type: 'error',
            },
          }
      );
     }
   });
  }

  freemiumAvailable(): void {
    const data = JSON.parse(localStorage.getItem(StorageKeyEnum.User));
    if (data.isShipyard === 1 && data.freemiumAvail) {
      data.freemiumAvail = false;
      this.authService.userInfo$.next(data);
      localStorage.setItem(StorageKeyEnum.User, JSON.stringify(data));
    }
  }

  mergeShip() {
      this.shipyardService
      .MergeShipment(this.data.shipmentHeaderId, this.selectedShipment)
      .pipe(takeUntil(this.destroy$)).subscribe({
        next: (res:any) => {
          this.loading = false;
          this.freemiumAvailable();
          this.dialogRef.close();
          this.router.navigate(["/shipyard/shipments/detail/" + this.selectedShipment]);
        },
       error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Error. Please try again',
              action: 'Dismiss',
                type: 'error',
            },
          }
      );
      this.loading = false;
       }
     });
  }

  editShipment() {
      this.shipyardService
      .EditShipmentSku({
        skus: this.data.skus,
        shipmentHeaderId: this.selectedShipment,
        appendQty: true,
      }).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res:any) => {
          this.loading = false;
          this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 4000,
                horizontalPosition: 'center',
                data: {
                  title: 'Edited successfully',
                  action: 'Dismiss',
                    type: 'success',
                },
              }
          );
          this.freemiumAvailable();
          this.dialogRef.close(this.selectedPlan);
        },
       error: (err) => {
        this.loading = false;
          this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 5000,
                horizontalPosition: 'center',
                data: {
                  title: err.error?.error[0],
                  action: 'Dismiss',
                    type: 'error',
                },
              }
          );
       }
     });
  }

  selectShipment(plan) {
    this.selectedShipment = plan.shipmentHeaderId;
    this.selectedPlan = plan;
  }

  selectShipmentPlan(shipmentPlanId, index) {
    this.selectedShipmentPlan = shipmentPlanId;
    this.selectedIndex = index;
  }

  action(e) {
    if (e === "Confirm") {
      this.confrim();
    } else if (e === "Back to Create Shipment") {
      this.close();
      this.createShipment();
    } else {
      this.close();
    }
  }

  planShipment() {
    this.close();
    this.dialog.open(PlanShipmentDialogComponent, {
      width: "600px",
      data: {
        warehouses$: this.settingsService.GetAllWarehouses().pipe(shareReplay()),
        isDraft: false,
        title: "Plan Shipment",
      },
    });
  }

  createShipment() {
    this.close();
    this.dialog.open(PlanShipmentDialogComponent, {
      width: "720px",
      panelClass: "create-shipment",
      data: {
        warehouses$: this.settingsService.GetAllWarehouses().pipe(shareReplay()),
        isDraft: true,
        title: "Create Shipment",
        selectedSkus: this.response.selectedSku,
      },
    });
  }

  createDraft() {
    const payload: CreateDraftShipmentPayload = {
      account: this.account[0],
      shipmentName:'',
      shipmentType: this.data.shipmentTypeId,
      fromWarehouse: this.data.fromWareHouseId,
      skus: this.data.skus,
    };
      this.shipyardService
      .CreateShipmentDraft(payload).pipe(takeUntil(this.destroy$)).subscribe({
        next: (e:ShipmentDetail) => {
          this.dialogRef.close();
          this.shipyardService.skusToAddToShipment = [];
          this.router.navigate(["shipyard/shipments/detail/" + e.shipmentHeaderId]);
        },
       error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: err?.error?.error[0],
              action: 'Dismiss',
                type: 'error',
            },
          }
      );
       }
     });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
